import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * AnyAdminRoute
 *
 * Allows access if the user is a global admin (roleName === 'admin') OR has any
 * active org-level admin role (org_admin or course_admin). Used to gate
 * discovery pages like /my-classes and /admin/organizations.
 *
 * Wrap inside ProtectedRoute / AppLayout — this guard assumes the user is
 * already authenticated.
 */
export default function AnyAdminRoute({ children }) {
  const { user, hasAnyOrgAdminRole, isInitialized } = useAuth();
  if (!isInitialized) return null;
  const isGlobalAdmin = user?.roles?.some(r => r.roleName === 'admin');
  if (!isGlobalAdmin && !hasAnyOrgAdminRole()) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
